import React from 'react';
import { ExternalLink, Award, CheckCircle } from 'lucide-react';

const ADACPartner = ({ variant = 'full' }) => {
  const adacUrl = 'https://www.adac.de/services/schluesseldienst/dortmund/';

  // Kompakte Badge für Footer
  if (variant === 'badge') {
    return (
      <a
        href={adacUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-3 bg-white rounded-lg px-4 py-3 hover:shadow-lg transition-all border border-gray-200"
        title="ADAC Schlüsseldienst Partner"
      >
        <picture>
          <source srcSet="/images/adac-partner-logo.webp" type="image/webp" />
          <img
            src="/images/adac-partner-logo.jpg"
            alt="ADAC Schlüsseldienst Partner Logo"
            className="h-12 w-auto object-contain"
            loading="lazy"
            width="120"
            height="58"
            decoding="async"
          />
        </picture>
      </a>
    );
  }

  // Inline-Variante für Text
  if (variant === 'inline') {
    return (
      <a
        href={adacUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-sm text-gray-700 hover:text-orange-600 transition-colors"
      >
        <Award className="w-4 h-4 text-orange-600" />
        <span className="font-semibold">ADAC Schlüsseldienst Partner</span>
        <ExternalLink className="w-3 h-3" />
      </a>
    );
  }

  // Vollständige Sektion
  return (
    <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 border border-gray-200">
      <div className="flex flex-col md:flex-row items-center gap-6">
        <div className="flex-shrink-0">
          <a
            href={adacUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="block hover:opacity-90 transition-opacity"
            title="ADAC Schlüsseldienst Partner"
          >
            <picture>
              <source srcSet="/images/adac-partner-logo.webp" type="image/webp" />
              <img
                src="/images/adac-partner-logo.jpg"
                alt="ADAC Schlüsseldienst Partner - Zertifizierter Partnerbetrieb"
                className="h-24 w-auto object-contain"
                width="200"
                height="96"
                loading="lazy"
                decoding="async"
              />
            </picture>
          </a>
        </div>
        
        <div className="flex-1 text-center md:text-left">
          <div className="flex items-center gap-2 mb-2 justify-center md:justify-start">
            <Award className="w-5 h-5 text-orange-600" />
            <h3 className="text-xl font-bold text-gray-900">
              ADAC Schlüsseldienst Partner
            </h3>
          </div>
          <p className="text-gray-700 mb-3">
            Wir sind offizieller <strong>ADAC Schlüsseldienst Partner in Dortmund</strong>. 
            Das bedeutet für Sie: geprüfte Qualität, transparente Preise und zuverlässiger Service.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-600" />
              <span>ADAC-geprüfter Betrieb</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-600" />
              <span>Transparente Festpreise</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-600" />
              <span>24/7 Verfügbarkeit</span>
            </div>
          </div>
          
          <a
            href={adacUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-orange-600 hover:text-orange-700 font-semibold mt-4 hover:underline"
          >
            Mehr über ADAC Schlüsseldienst Partner
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ADACPartner;
